import styles from "../../static/styles/RoxESL/RoxLanding.module.css";

import roxCredits from '../../static/img/RoxESL/RoxESLCredits.png';

const rewards = [
    { number: '1', title: 'Daily Login', value: '+10', tone: 'green' },
    { number: '2', title: 'Complete Daily Task', value: '+50', tone: 'yellow' },
    { number: '3', title: 'Win a Match', value: '+100', tone: 'red' },
    { number: '4', title: 'Watch Highlights', value: '+25', tone: 'blue' },
];

const RoxCreditsSlide = () => (
    <div className={styles.RoxSlide}>
        <img className={styles.RoxCreditsImage} src={roxCredits} alt="" />
        <span className={styles.RoxCreditsTitle}>EARN ESL CREDITS</span>
        <p className={styles.RoxCreditsMsg}>Five ways to power up your wallet</p>
        <div className={styles.RoxCreditsList}>
            {rewards.map((reward) => (
                <div
                    className={`${styles.RoxCreditItem} ${styles[`RoxCreditItem${reward.tone}`]}`}
                    key={reward.title}
                >
                    <span className={styles.RoxCreditNumber}>{reward.number}</span>
                    <span className={styles.RoxCreditText}>
                        <strong>{reward.title}</strong>
                        <small>tap to learn more</small>
                    </span>
                    <span className={styles.RoxCreditValue}>{reward.value}</span>
                </div>
            ))}
        </div>
    </div>
);

export default RoxCreditsSlide;
